import React from 'react';
import Routes from './Routes/index';
import { ThemeProvider } from '@mui/styles';
import { createTheme } from '@mui/material/styles';
import './assets/scss/themes.scss';
import { store } from './Redux/store';
import { Provider } from 'react-redux';
import { CookiesProvider } from 'react-cookie';
import { PersistGate } from 'redux-persist/integration/react';
import { persistStore } from 'redux-persist';
import SignalRApp from './SignalR';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

const theme = createTheme();

function App() {
  var layoutMode = document.body.getAttribute('data-layout-mode');
  let persistor = persistStore(store);
  const queryClient = new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 5 * 60 * 1000, // 5 minutes
        cacheTime: 10 * 60 * 1000 // 10 minutes
      }
    }
  });
  return (
    <ThemeProvider theme={theme}>
      <CookiesProvider>
        <Provider store={store}>
          <PersistGate loading={null} persistor={persistor}>
            <QueryClientProvider client={queryClient}>
              <SignalRApp />
            </QueryClientProvider>
          </PersistGate>
        </Provider>
      </CookiesProvider>
    </ThemeProvider>
  );
}

export default App;
